export default "__VITE_ASSET__f97d39ab__"